import {
  SOCIETE_LISTE_REQUETTE,
  SOCIETE_LISTE_SUCCES,
  SOCIETE_LISTE_ECHEC,
  SOCIETE_ACTUELLE,
  SOCIETE_CREATION_REQUETTE,
  SOCIETE_CREATION_SUCCES,
  SOCIETE_CREATION_ECHEC,
  SOCIETE_UPDATE_REQUETTE,
  SOCIETE_UPDATE_SUCCES,
  SOCIETE_UPDATE_ECHEC,
  SOCIETE_DETAILS_REQUETTE,
  SOCIETE_DETAILS_SUCCES,
  SOCIETE_DETAILS_ECHEC,
} from "../constantes/societeConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;

//const uri = "https://164.132.56.133:5000";
//const uri = "https://ahmed.prod-manager.tk:5000";
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
//const uri = "http://localhost:5000";
//------------------------------------------------------------------------------------------------------------
//l'action c'es une fonction qui va executer une requete en utilisant l'axios ou une iterrogation avec le state a traver le reducer
import { store } from "../store";
let uri = "";
console.log(process.env);
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

export const listeSocietes = () => async (dispatch) => {
  try {
    //c'est l'action qui va etre execute a partir de composant loginClient avec la commande dispatch(listeSocietes())
    //le rol de sette action est de lancer une requete qui va selectionnée la liste des societe a partir de la base et le mettrre dans le variable data
    const { data } = await axios.get(`${uri}/api/societe`);
    console.log("soc action:" + `${uri}/api/societe`);
    //dispatch de SOCIETE_LISTE_SUCCES vers le reducer avec payload qui va contient un data(voir reducer)
    dispatch({ type: SOCIETE_LISTE_SUCCES, payload: data });
  } catch (error) {
    console.log(error);
    //dans le cas echec on dispatch vers le reducer un type SOCIETE_LISTE_ECHEC avec un payload qui va contenir l'erreur(voir reducer)
    dispatch({
      type: SOCIETE_LISTE_ECHEC,
      payload: error?.response?.data?.message,
    });
  }
};
//------------------------------------------------------------------------------------------------------------
export const societeActuelle = (societe) => async (dispatch) => {
  //const fin = JSON.parse(societe);

  dispatch({ type: SOCIETE_ACTUELLE, payload: societe });
};

export const creerSociete =
  (nom_soc, code_soc, abrv_soc, adr_soc, tel_cli, tva_soc) =>
  async (dispatch) => {
    dispatch({ type: SOCIETE_CREATION_REQUETTE });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${uri}/api/societe`,
        { nom_soc, code_soc, abrv_soc, adr_soc, tel_cli, tva_soc },
        config
      );
      dispatch({ type: SOCIETE_CREATION_SUCCES, payload: data });
    } catch (error) {
      dispatch({ type: SOCIETE_CREATION_ECHEC, payload: error });
      console.log(error);
    }
  };

export const updateSociete =
  (nom_soc, code_soc, abrv_soc, adr_soc, tel_cli, tva_soc, id) =>
  async (dispatch) => {
    dispatch({ type: SOCIETE_UPDATE_REQUETTE });
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${uri}/api/societe/${id}`,
        { nom_soc, code_soc, abrv_soc, adr_soc, tel_cli, tva_soc },
        config
      );
      dispatch({ type: SOCIETE_UPDATE_SUCCES, payload: data });
    } catch (error) {
      dispatch({ type: SOCIETE_UPDATE_ECHEC, payload: error });
    }
  };

export const detailsSociete = (id) => async (dispatch) => {
  dispatch({ type: SOCIETE_DETAILS_REQUETTE });
  try {
    const { data } = await axios.get(`${uri}/api/societe/${id}`);
    dispatch({ type: SOCIETE_DETAILS_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: SOCIETE_DETAILS_ECHEC, payload: error.message });
  }
};
